import NotFoundCopy from './404/404-copy'
import CommonCopy from './common/common-copy'
import ForgotPasswordCopy from './forgot-password/forgot-password-copy'
import NavigationCopy from './navigation/navigation-copy'
import SignInCopy from './sign-in/sign-in-copy'
import ContentCopy from './admin/content/content-copy'
import CreateOrganisationCopy from './admin/create-organisation/create-organisation-copy'
import MissionsCopy from './admin/missions/missions-copy'
import QrCodeCopy from './admin/qr-codes/qr-code-copy'
import CodesCopy from './admin/signup-codes/signup-codes-copy'
import CodesDetailsCopy from './admin/signup-codes-details/signup-codes-details-copy'

const LOCALE = 'en-GB'

const messages = {
  ...CommonCopy,
  ...NotFoundCopy,
  ...SignInCopy,
  ...ForgotPasswordCopy,
  ...NavigationCopy,
  ...CodesCopy,
  ...CodesDetailsCopy,
  ...MissionsCopy,
  ...QrCodeCopy,
  ...ContentCopy,
  ...CreateOrganisationCopy,
}

export default {
  locale: LOCALE,
  messages,
}
